import axios from "axios";

var AxiosAuthenticationHandler = (function () {
    var initialize = function ({ xAuthToken }) {
        return _setAxiosToken(xAuthToken);
    }

    var terminate = function () {
        return _setAxiosToken(undefined);
    }

    var _setAxiosToken = function (token) {
        return axios.defaults.headers.common['X-AUTH-TOKEN'] = token;
    }

    return {
        initialize: initialize,
        terminate: terminate
    }
}());

export default AxiosAuthenticationHandler;
